import loadScript from '@gelato/utils/loadScript';
import styles from '@gelato/config/mapStyle';

export default async function(dom, opts) {
	let options = {
    locations: [],
		...opts
  };

  if (options.apiKey) {
    try {
      await loadScript(`https://maps.googleapis.com/maps/api/js?key=${options.apiKey}&language=de-CH&region=ch`);

      const map = new google.maps.Map(dom, {
        center: {
          lat: 46.8182,
          lng: 8.2275
        },
        zoom: 8,
        mapTypeId: 'roadmap',
        gestureHandling: 'cooperative',
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          mapTypeIds: ['roadmap', 'satellite'],
        },
        styles,
      });

      const infowindow = new google.maps.InfoWindow({
        maxWidth: 540
      });

      // TODO: there will probably be different icons for the different location types (delivery, gelateria etc.)
      const icons = {
        geo: {
          url: '/files/gelato/images/map-geo.svg',
          size: new google.maps.Size(33, 45),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 45),
          scaledSize: new google.maps.Size(33, 45),
        }, // TODO: implement geolocation and add separate icon to show current location on map
        pin: {
          url: '/files/gelato/images/map-pin.svg',
          size: new google.maps.Size(33, 45),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 45),
          scaledSize: new google.maps.Size(33, 45),
        },
        restaurant: {
          url: '/files/gelato/images/map-restaurant.svg',
          size: new google.maps.Size(33, 45),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 45),
          scaledSize: new google.maps.Size(33, 45),
        },
        gelateria: {
          url: '/files/gelato/images/map-gelateria.svg',
          size: new google.maps.Size(33, 45),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 45),
          scaledSize: new google.maps.Size(33, 45),
        },
        delivery: {
          url: '/files/gelato/images/map-delivery.svg',
          size: new google.maps.Size(33, 45),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 45),
          scaledSize: new google.maps.Size(33, 45),
        },
      };

      let locationMarker;
      const bounds = new google.maps.LatLngBounds();
      const markers = options.locations.map(location => {
        const marker = new google.maps.Marker({
          map,
          position: location.position,
          title: location.title,
          draggable: false,
          animation: google.maps.Animation.DROP,
          optimized: false,
          icon: icons[location.type] ? icons[location.type] : icons.pin,
          zIndex: 100,
        });

        marker.addListener('click', () => {
          infowindow.setContent(location.content);
          infowindow.open(map, marker);
        });

        // TODO: create a function for this, so it can be updated when geolocation is used
        bounds.extend(marker.getPosition());

        return marker;
      });

      if (locationMarker) {
        bounds.extend(locationMarker.position);
      }

      map.fitBounds(bounds);
    }
    catch(error) {
      // console.error(error);
    }
  }
}
